import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

export class SearchForm extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    defaultValues: PropTypes.object,
    searchAction: PropTypes.func.isRequired,
    valueChangeDelay: PropTypes.number,
    valueOverride: PropTypes.bool,
  };

  static defaultProps = {
    valueOverride: true,
    valueChangeDelay: 500,
  };

  constructor(props) {
    super(props);
    this.renderFields = this.renderFields.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.executeSearch = this.executeSearch.bind(this);
    this.state = {
      data: Object.assign({}, props.defaultValues),
    };
  }

  componentDidMount() {
    // make sure default value isn't empty
    if (this.props.defaultValues && this.props.defaultValues.searchValue) {
      this.executeSearch();
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    if (this.props.defaultValues && !isEqual(this.props.defaultValues, prevState.data)) {
      const data = this.props.valueOverride ? this.props.defaultValues : Object.assign({}, prevState.data);
      this.setState({ data });
    }
  }

  onValueChange(obj) {
    const data = Object.assign({}, this.state.data, obj);
    this.setState({ data }, this.executeSearch);
  }

  executeSearch() {
    if (this.props.disabled) {
      return;
    }

    const searchParams = Object.assign({}, this.state.data);
    this.props.searchAction(searchParams);
  }

  renderFields() {
    return React.Children.map(
      this.props.children,
      child => {
        if (child.type === 'div') {
          return child;
        } else {
          return React.cloneElement(child, {
            onValueChange: this.onValueChange,
            data: this.state.data,
            valueChangeDelay: this.props.valueChangeDelay,
            disabled: this.props.disabled,
          });
        }
      },
      this
    );
  }

  render() {
    return (
      <form className={this.props.className} role="form" data-action="search-wrapper">
        {this.renderFields()}
      </form>
    );
  }
}
